export const enum API_NAME {
  ALTERNATIVE_DATES = 'search/alternativeDates',
  APP_LOGGER = 'appLogger',
  AUTOCOMPLETE_HOTEL = 'search/autocompletehotel',
  CASPER_TOKEN = 'casperToken',
  COMPARE = 'search/compare',
  DYNAMIC_FILTERS = 'search/dynamicfilters',
  EVENTS = 'events',
  PAGE_WRAPPER_DATA = 'pageWrapperData',
  PRODUCTS = 'search/products',
  RTCO_CLICK_HOTEL = 'search/rtcoclickhotel',
  RTCO_VIEW_HOTEL = 'search/rtcoviewhotel',
  SEARCH_DEFAULT_DATA = 'search/searchDefaultData',
  SEARCH_PROGRESS = 'search/searchProgress',
  SEARCH_PAGE_DATA = 'search/searchPageData',
  TIMINGS = 'search/timings',
}
